module.exports = __webpack_public_path__ + "bin/865fa811ce353b4d5b687dbefedbbecc.png";